import React, { useContext, useState, useEffect } from "react";
import {
  Modal,
  Button,
  Typography,
  Box,
  CircularProgress,
  useTheme,
} from "@mui/material";
import { styled, useMediaQuery } from "@mui/system";
import { motion } from "framer-motion";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import GlobalStateContext from "../context/globalStateContext";
import { COLORS } from "../utils/COLORS";
import UserContext from "../context/userContext";
import { firebase, functions, firestore } from "../firebaseConfig";
import { httpsCallable } from "firebase/functions";
import * as amplitude from '@amplitude/analytics-browser';

const StyledModal = styled(Modal)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "center",
}));

const ModalContent = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderTopLeftRadius: theme.shape.borderRadius,
  borderTopRightRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[5],
  padding: theme.spacing(4),
  outline: "none",
  width: "90%",
  maxWidth: "400px",
  maxHeight: "80vh",
  overflowY: "auto",
  textAlign: "center",
}));

const SaviorRewardInfoModal = ({ open, onClose }) => {
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <StyledModal
      open={open}
      onClose={onClose}
      BackdropProps={{
        style: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
      }}
    >
      <motion.div
        initial={{ y: "100%" }}
        animate={{ y: 0 }}
        exit={{ y: "100%" }}
        onClick={onClose}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: isMobileView ? "flex-end" : "center",
          height: "100%",
        }}
      >
        <ModalContent onClick={(e) => e.stopPropagation()}>
          <Typography
            variant="h5"
            sx={{ fontWeight: "bold", color: COLORS.primaryGreen, mb: 3 }}
          >
            Hero Reward Program
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
              color: "black",
              lineHeight: "1.6",
              marginBottom: "24px",
            }}
          >
Get paid to save dogs from death row. List at-risk shelter
  dogs → Help them get rescued → Earn 15% of pledges. 350K+
  dogs killed yearly never get this chance. You can change
  that. Be their voice. Get rewarded.
            {/* 350,000+ dogs yearly in USA shelters are killed without a chance to raise rescue pledges. PledgeFast members who list then get at-risk dogs rescued get rewarded (opt-in) a savior reward. This is 15% one-time pledges excluding subscriptions. Earn an income saving dogs! Join us in ending dog euthanasia. Only kill-shelter dogs are eligible. You must be the original poster of the dog to earn the savior reward. */}
          </Typography>
          <Button
            variant="contained"
            fullWidth
            onClick={onClose}
            sx={{
              backgroundColor: COLORS.primaryGreen,
              "&:hover": {
                backgroundColor: COLORS.darkGreen,
              },
            }}
          >
            Got it
          </Button>
          <Typography
            sx={{
              fontSize: "14px",
              color: "#6B7280",
              marginTop: "8px",
            }}
          >
            onepaceapps@gmail.com
          </Typography>
        </ModalContent>
      </motion.div>
    </StyledModal>
  );
};

export default SaviorRewardInfoModal;
